/**
 * Customer self-service addresses.
 *
 * Wraps GET/POST/PATCH/DELETE /api/v1/customers/me/addresses. The
 * checkout page and the profile-page address book both call into this
 * module — same shapes the backend persists.
 */

import { apiClient } from './apiClient';

export type AddressType = 'shipping' | 'billing';

export interface Address {
  id: number;
  user_id: number;
  address_type: AddressType;
  address_line1: string;
  address_line2: string | null;
  city: string;
  state: string;
  zip_code: string;
  is_default: boolean;
  created_at: string;
  updated_at: string;
}

export interface AddressInput {
  address_type: AddressType;
  address_line1: string;
  address_line2?: string;
  city: string;
  state: string;
  zip_code: string;
  is_default?: boolean;
}

function unwrapList(raw: any): Address[] {
  if (Array.isArray(raw)) return raw as Address[];
  if (Array.isArray(raw?.data)) return raw.data as Address[];
  return [];
}

export async function listMyAddresses(): Promise<Address[]> {
  const raw = await apiClient.get<any>('/customers/me/addresses');
  return unwrapList(raw);
}

export async function createMyAddress(input: AddressInput): Promise<Address> {
  return apiClient.post<Address>('/customers/me/addresses', input);
}

export async function updateMyAddress(id: number, input: Partial<AddressInput>): Promise<Address> {
  return apiClient.patch<Address>(`/customers/me/addresses/${id}`, input);
}

export async function deleteMyAddress(id: number): Promise<void> {
  await apiClient.delete<void>(`/customers/me/addresses/${id}`);
}
